import {useContext} from 'react';
import {Link, SubLink} from 'react-router-dom';
import { useRef } from 'react';
import NavigationComponent from '../../navigation/navigation.component';
import LB from '../../images/games/LeftButton.png';
import RB from '../../images/games/RightButton.png';
import { GallaryContext } from '../../contexts/image-gallary.context';

import { Paragraph, Background, Gradient, OppGradient, ProjDeets, PData, Header1, Alinks, GalleryContainer, GalleryArrow, GalleryImages} from './epiphany-dice.styles';

const EpiphanyDice = () => {
     const {currentEDImage, EDGallaryNext, EDGallaryPrevious} = useContext(GallaryContext);

    return (
        <Background>
            <NavigationComponent></NavigationComponent>
            <Gradient></Gradient>
            <Header1>Epiphany Dice</Header1>
        <ProjDeets>
            <Paragraph>This was my first website design based comission.  This company desired to utilize Shopify's build in website design system to make an appealing and unique website that fit their brand's vibe.  However, they did not have the website design experience and in turn enlisted my help for assistance.</Paragraph>
            <Paragraph>Making this website look the way it does now was a huge learning curve for me.  I am used to the design principles of websites such as SquareSpace, or building a website from scratch.</Paragraph>
            <Paragraph>Despite my original limitations, I jumped in head first and began to learn what makes Shopify API unique.  I created a feature which allowed customers to input customization details within text boxes which would appear on the website owners' end once the order was submitted.  I also set up the system to allow custom fonts that the website owners had chosen.</Paragraph>
            <Paragraph>I utilized their logo and banner colors to set up a matching color scheme for the entire website.  Lastly, I created defaults for the website owners so they could easilly create templates for regular items and customized items, so they would not need to touch the code themselves at any point.  I also taught them how to set up these items theemselves if they chose to do so in the future.</Paragraph>
            <Paragraph><Alinks href="https://epiphanydice.com/">Click here to visit Epiphany Dice to view my work and their wares.</Alinks></Paragraph>
            <PData>
                <strong>Project Type:</strong> FrontEnd <br/>
                <strong>Date Completed: </strong> February 2025 <br/>
                <strong>Skills Used: </strong>HTML, CSS, Shopify API
            </PData>
        </ProjDeets>
         <GalleryContainer>
                        <GalleryArrow left src={LB} onClick={EDGallaryPrevious}></GalleryArrow>
                        <GalleryImages src={currentEDImage} ></GalleryImages>
                        <GalleryArrow right src={RB} onClick={EDGallaryNext}></GalleryArrow>
                    </GalleryContainer>
        <OppGradient></OppGradient>
        </Background>
    )
}

export default EpiphanyDice;